import { mutate } from 'swr';
import axios from 'axios';
import { TDealFee } from '../../../interfaces';
import { Notistack } from '../../../../../../../shared/components/Notistack/Notistack';

export const requestCreateDealFee = (lenderId: string, dealFee: TDealFee) => {
  const path = `/lender-service/lenders/${lenderId}/dealFee`;
  return mutate(`/lender-service/lenders/${lenderId}`, async() => {
    try {
      await axios.put(path, {
        category: dealFee?.category,
        description: dealFee?.description,
        amount: Number(dealFee?.amount),
        minFico: Number(dealFee?.minFico),
        maxFico: Number(dealFee?.maxFico),
        isCurrent: dealFee?.isCurrent,
        isIncluded: dealFee?.isIncluded,
        isDocFee: dealFee?.isDocFee,
      });
      Notistack.successMessage('Additional Doc Fee - Created Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};

export const requestUpdateDealFee = (lenderId: string, dealFee: TDealFee) => {
  const path = `/lender-service/lenders/${lenderId}/dealFee`;
  return mutate(`/lender-service/lenders/${lenderId}`, async() => {
    try {
      await axios.patch(path, dealFee);
      Notistack.successMessage('Additional Doc Fee - Updated Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};

export const requestDeleteDealFee = (lenderId: string, dealFeeId = '') => {
  const path = `/lender-service/lenders/${lenderId}/dealFee/${dealFeeId}`;
  return mutate(`/lender-service/lenders/${lenderId}`, async() => {
    try {
      await axios.delete(path);
      Notistack.successMessage('Additional Doc Fee - Deleted Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};
